<template>
    <section>
        <figure></figure>
        <table>
            <thead>
                <tr>
                    <th colspan="2">Dimensions</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Width :</td>
                    <td><input v-model.number="data.width" type="number" id="width" name="width" /> mm</td>
                </tr>

                <tr>
                    <td>Height :</td>
                    <td><input v-model.number="data.height" type="number" id="height" name="height" /> mm</td>
                </tr>

                <tr>
                    <td>Ticket strip Height :</td>
                    <td><input v-model.number="data.coverHeight" type="number" id="coverHeight" name="coverHeight" /> mm</td>
                </tr>
                <tr>
                    <td>Ticket strip Y :</td>
                    <td><input v-model.number="data.coverY" type="number" id="coverY" name="coverY" /> mm</td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th colspan="2">Left anchor</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>x :</td>
                    <td>
                        <input
                            :value="data.leftClip.x + data.width / 2"
                            @input="e => (data.leftClip.x = Number.parseFloat(e.target.value, 10) - data.width / 2)"
                            type="number"
                            id="leftClipX"
                            name="leftClipX"
                        />
                        mm
                    </td>
                </tr>

                <tr>
                    <td>y :</td>
                    <td>
                        <input
                            :value="data.height / 2 - data.leftClip.y"
                            @input="e => (data.leftClip.y = -Number.parseFloat(e.target.value, 10) + data.height / 2)"
                            type="number"
                            id="leftClipY"
                            name="leftClipY"
                        />
                        mm
                    </td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th colspan="2">Right anchor</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>x :</td>
                    <td>
                        <input
                            :value="data.width / 2 - data.rightClip.x"
                            @input="e => (data.rightClip.x = -Number.parseFloat(e.target.value, 10) + data.width / 2)"
                            type="number"
                            id="rightClipX"
                            name="rightClipX"
                        />
                        mm
                    </td>
                </tr>

                <tr>
                    <td>y :</td>
                    <td>
                        <input
                            :value="data.height / 2 - data.rightClip.y"
                            @input="e => (data.rightClip.y = -Number.parseFloat(e.target.value, 10) + data.height / 2)"
                            type="number"
                            id="rightClipY"
                            name="rightClipY"
                        />
                        mm
                    </td>
                </tr>
            </tbody>
        </table>

        <table>
            <thead>
                <tr>
                    <th colspan="2">Misc</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>is bottom adhesive :</td>
                    <td><input v-model.number="data.rightClip.bottomAdhesive" type="checkbox" id="bottomAdhesive" name="bottomAdhesive" /></td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
import { assertValidShelfConfig } from "@/utils/validators";

export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        validate() {
            assertValidShelfConfig(this.data);

            const { width, height, coverHeight, coverY, leftClip, rightClip, bottomAdhesive } = this.data;

            function assertIsType(type, value, msg) {
                console.assert(typeof value === type, msg);
            }

            // TODO: size/positions should be based on bottom left then converted to center
            // TODO: Translate error messages
            // TODO: Translate form

            // we recreate an object with only the needed values
            // it ensures that there's no extra pointless field or that Vue made it weird
            return {
                width,
                height,
                coverHeight,
                coverY,
                leftClip: {
                    x: leftClip.x,
                    y: leftClip.y
                },
                rightClip: {
                    x: rightClip.x,
                    y: rightClip.y
                },
                bottomAdhesive
            };
        }
    }
};
</script>
<style lang="scss" scoped>
input {
    width: 130px;
}

section {
    flex-grow: 1;
    padding: 10px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 400px);
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    justify-content: center;
    align-content: start;

    > figure {
        border: gray 2px solid;
        padding-bottom: 60%;
    }
}
</style>



// WEBPACK FOOTER //
// shelf-form.vue?e991fe66